/* eslint-disable no-underscore-dangle, no-unused-vars */

const callbackMap = new Map();

function bind(el, handler, vNode) {
    // eslint-disable-next-line func-names
    const callback = function (e) {
        if (vNode.context._isDestroyed) {
            /**
             * Cleaning up any unwanted handlers. This covers the scenario where a child component with this directive
             * has a parent which gets destroyed. The child is not able to unbind its directive properly.
             */
            document.removeEventListener('click', callback);
            return;
        }

        if (!el.contains(e.target) && el !== e.target) {
            handler(e);
        }
    };

    callbackMap.set(el, callback);
    setTimeout(() => document.addEventListener('click', callback), 0);
}

function unbind(el) {
    const callback = callbackMap.get(el);
    document.removeEventListener('click', callback);
    callbackMap.delete(el);
}

export default {
    bind(el, { arg: { active, handler } }, vNode) {
        if (typeof handler !== 'function') {
            throw new Error('v-click-outside: missing required handler argument.');
        }

        if (active === true) {
            bind(el, handler, vNode);
        }
    },
    update(el, { arg: { active, handler } }, vNode) {
        if (active && !callbackMap.has(el)) {
            bind(el, handler, vNode);
        } else if (!active && callbackMap.has(el)) {
            unbind(el);
        }
    },
    unbind(el) {
        unbind(el);
    }
};
